import { render, staticRenderFns } from "./StudentContactInfoView.vue?vue&type=template&id=68f925a2&scoped=true"
import script from "./StudentContactInfoView.vue?vue&type=script&lang=js"
export * from "./StudentContactInfoView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f925a2",
  null
  
)

export default component.exports